import AppFixed from '../../mixins/app-fixed'
import CoreResize from '../../mixins/core-resize'

let numDisplay = 0

export default
{
    name: 'app-loader',

    mixins:
    [
        AppFixed,
        CoreResize
    ],

    data()
    {
        return {
            columns: 10,
            lines: 10,
            displayLoader: true
        }
    },

    created()
    {
        this.displayLoader = numDisplay++ < 1 || this.$root.$route.name === 'page-home'
        this.onResized(this.resize.width, this.resize.height)
    },

    methods:
    {
        rand(min, max, seed = Math.random())
        {
            return Math.round((max - min) * seed + min)
        },

        getShift(num)
        {
            const shift = Math.ceil(num / 3)
            return ((1 + num - (this.columns >> 1) - shift) * 100 / this.lines).toFixed(2)
        },

        onResized(w, h)
        {
            this.columns = Math.ceil(w / 250)
            this.lines = Math.ceil(h / 250)
        },

        getRgb()
        {
            const seed = Math.random()
            const r = this.rand(5, 22, seed)
            const g = this.rand(5, 24, seed)
            const b = this.rand(7, 32, seed)
            return 'rgb(' + r + ',' + g + ',' + b + ')'
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-loader/script.js